import React, { useEffect, useState } from 'react';
import { Flame, AlertTriangle, Sparkles } from 'lucide-react';
const VISIT_KEY = 'reset_femenino_visited';
export function StickySpotCounter() {
  const isReturning = typeof window !== 'undefined' && localStorage.getItem(VISIT_KEY) === 'true';
  const [spots, setSpots] = useState(isReturning ? 3 : 8);
  const [animate, setAnimate] = useState(false);
  const [shake, setShake] = useState(false);
  const [flash, setFlash] = useState(false);
  const [hasDropped, setHasDropped] = useState(isReturning);
  const [returningUser] = useState(isReturning);
  // Mark as visited
  useEffect(() => {
    localStorage.setItem(VISIT_KEY, 'true');
  }, []);
  // First visit: drop from 8 to 5 after 7 seconds, then to 4 after 30 seconds
  useEffect(() => {
    if (returningUser) return;
    const firstDrop = setTimeout(() => {
      triggerAnimation();
      setSpots(5);
      setHasDropped(true);
    }, 7000);
    const secondDrop = setTimeout(() => {
      triggerAnimation();
      setSpots(4);
    }, 30000);
    return () => {
      clearTimeout(firstDrop);
      clearTimeout(secondDrop);
    };
  }, [returningUser]);
  const triggerAnimation = () => {
    setFlash(true);
    setTimeout(() => setFlash(false), 300);
    setAnimate(true);
    setTimeout(() => setAnimate(false), 1000);
    setShake(true);
    setTimeout(() => setShake(false), 800);
  };
  const isLow = spots <= 5;
  const urgencyText = returningUser ? 'Hemos habilitado 5 espacios más únicamente' : '¡No te quedes sin tu espacio! Reserva YA!';
  return <div className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-300 ${flash ? 'bg-red-600' : isLow ? 'bg-gradient-to-r from-brand-dark via-brand-clay to-brand-dark' : 'bg-brand-dark/95'} backdrop-blur-md border-t ${isLow ? 'border-brand-clay/50' : 'border-brand-eucalyptus/50'} shadow-[0_-4px_30px_rgba(0,0,0,0.25)]`} style={{
    animation: shake ? 'shake 0.5s ease-in-out' : 'none'
  }} data-id="element-5">
      {/* Animated urgency glow when low */}
      {isLow && <div className="absolute inset-0 bg-brand-clay/10 animate-pulse pointer-events-none" data-id="element-6"></div>}

      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-4 relative" data-id="element-7">
        {/* Left: Spots counter + urgency text */}
        <div className="flex items-center gap-3 min-w-0" data-id="element-8">
          <div className="flex items-center gap-2 flex-shrink-0" data-id="element-9">
            {returningUser ? <Sparkles className="h-5 w-5 text-brand-peach animate-pulse" data-id="element-10" /> : isLow ? <AlertTriangle className="h-5 w-5 text-brand-peach animate-bounce" data-id="element-11" /> : <Flame className="h-5 w-5 text-brand-peach animate-pulse" data-id="element-12" />}
            <span className="text-brand-pistachio text-xs sm:text-sm whitespace-nowrap font-medium" data-id="element-13">
              Espacios disponibles:
            </span>
            <span className={`inline-flex items-center justify-center min-w-[2.5rem] h-9 px-3 rounded-lg font-black text-lg sm:text-xl tabular-nums transition-all ${animate ? 'scale-150 bg-brand-clay text-white ring-4 ring-brand-clay/50 shadow-lg shadow-brand-clay/50' : isLow ? 'scale-100 bg-brand-clay/90 text-white shadow-md shadow-brand-clay/30' : 'scale-100 bg-brand-peach text-brand-dark'}`} style={{
            transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)'
          }} data-id="element-14">
              {spots}
            </span>
          </div>
          <span className={`text-xs sm:text-sm font-bold hidden sm:inline truncate ${returningUser ? 'text-brand-peach' : isLow ? 'text-brand-peach' : 'text-brand-pistachio'}`} data-id="element-15">
            {urgencyText}
          </span>
        </div>

        {/* Right: CTA button */}
        <button onClick={() => window.open('https://pay.hotmart.com/A104324565P?off=pi9fadac', '_blank')} className={`flex-shrink-0 px-5 sm:px-7 py-2.5 font-bold text-xs sm:text-sm rounded-full transition-all duration-300 whitespace-nowrap ${isLow ? 'bg-brand-ivory text-brand-clay hover:bg-white shadow-lg shadow-white/20 animate-pulse' : 'bg-brand-clay hover:bg-[#C89268] text-white hover:shadow-lg hover:shadow-brand-clay/30'}`} data-id="element-16">
          🔥 Reservar ahora
        </button>
      </div>

      {/* Mobile urgency text */}
      <div className="sm:hidden text-center pb-2 -mt-1" data-id="element-17">
        <span className={`text-[11px] font-bold ${returningUser ? 'text-brand-peach' : isLow ? 'text-brand-peach' : 'text-brand-pistachio'}`} data-id="element-18">
          {urgencyText}
        </span>
      </div>

      <style data-id="element-19">{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          10%, 30%, 50%, 70%, 90% { transform: translateX(-3px); }
          20%, 40%, 60%, 80% { transform: translateX(3px); }
        }
      `}</style>
    </div>;
}